import {environment} from '../environments/environment';

export class Config {
    public static readonly version: string = environment.VERSION;
    public static readonly URL: string = environment.URL;
    public static readonly urlFile: string = environment.urlFile;
    public static readonly apiKey: string = environment.apiKeyGoogle;
}
